module.exports = __webpack_public_path__ + "cancellara-dist/img/well-work.fd6ab060.png";